module.exports = {
	ExternalInterface: require("./ExternalInterface").default,
}